import ApprovedRequests from "../../components/Requests/ApprovedRequests";
import PendingRequest from "../../components/Requests/PendingRequests";
import RejectedRequests from "../../components/Requests/RejectedRequests";

export const tabBarOptions = [
  { id: 1, title: "Pending Requests", Component: PendingRequest },
  { id: 2, title: "Approved Requests", Component: ApprovedRequests },
  { id: 3, title: "Rejected Requests", Component: RejectedRequests },
];
